import { LifeBuoy, QrCode, Headset, CalendarClock, Settings2, BellRing, LayoutDashboard, BookOpen } from 'lucide-react';
import MisReportes from '../tickets/MisReportes';
import EtiquetasActivos from '../tickets/EtiquetasActivos';
import MesaDeAyuda from '../tickets/MesaDeAyuda';
import TableroEncargado from '../tickets/TableroEncargado';
import Guardia from '../tickets/Guardia';
import ConfiguracionMesa from '../tickets/ConfiguracionMesa';
import FuentesAutomaticas from '../tickets/FuentesAutomaticas';
import BaseConocimiento from '../tickets/BaseConocimiento';

/* =====================================================================
   Las pantallas del carril `tickets` · DIRECTRIZ-TICKETS F2
   =====================================================================
   El menú las monta solo: se deja este archivo y aparecen, sin tocar el
   caliente `ui/modulos.jsx`.

   Las dos van en «Operación», que es donde se trabaja:
     · «Mis reportes» la ve CUALQUIERA (min CONSULTA): todo el mundo puede
       reportar y seguir lo suyo (permiso `tickets.ver_propios`, de fábrica
       en todos los roles).
     · «Etiquetas QR» es de quien atiende (min OPERADOR): el encargado
       imprime las etiquetas de los activos y las pega.

   La F3 añade la mesa de atención (cola del técnico con SLA), los turnos de
   guardia y la configuración de la mesa. El botón flotante «Reportar un
   problema» de TODA pantalla lo monta el AppShell (parche del integrador,
   ver ENTREGA de F2).

   Quién ve qué:
     · «Mis reportes» — CUALQUIERA (todos reportan y siguen lo suyo).
     · «Mesa de ayuda» y «Etiquetas QR» — quien atiende (min OPERADOR).
     · «Turnos de guardia» y «Configuración de la mesa» — quien administra
       (min ADMIN): las dos ejecutan acciones de `tickets.administrar`, así
       que se muestran solo a quien las puede completar (no botones que
       terminen en un «no puedes»).
   ===================================================================== */
export default {
  orden: 62,
  grupos: [{
    grupo: 'Operación',
    items: [
      {
        id: 'mis-reportes',
        etiqueta: 'Mis reportes',
        icono: LifeBuoy,
        min: 'CONSULTA',
        Comp: MisReportes,
      },
      {
        id: 'tickets-mesa',
        etiqueta: 'Mesa de ayuda',
        icono: Headset,
        min: 'OPERADOR',
        Comp: MesaDeAyuda,
      },
      {
        id: 'tickets-etiquetas-qr',
        etiqueta: 'Etiquetas QR de activos',
        icono: QrCode,
        min: 'OPERADOR',
        Comp: EtiquetasActivos,
      },
      {
        // La base de conocimiento (F7) la ve CUALQUIERA (min CONSULTA): las
        // soluciones sirven a quien reporta. Crear/editar/retirar es de
        // quien atiende, y la pantalla oculta esos botones a quien no puede
        // (permiso `tickets.atender`), para no mostrar un «no puedes».
        id: 'tickets-conocimiento',
        etiqueta: 'Base de conocimiento',
        icono: BookOpen,
        min: 'CONSULTA',
        Comp: BaseConocimiento,
      },
      {
        // El tablero es de quien VE TODOS los tickets (encargado del área):
        // son los números de la mesa entera, respetando su alcance por
        // sucursal en el servidor. `min: ENCARGADO` alinea el menú con el
        // permiso `tickets.ver_todos`, para no mostrar lo que no podría abrir.
        id: 'tickets-tablero',
        etiqueta: 'Tablero del encargado',
        icono: LayoutDashboard,
        min: 'ENCARGADO',
        Comp: TableroEncargado,
      },
      {
        id: 'tickets-guardia',
        etiqueta: 'Turnos de guardia',
        icono: CalendarClock,
        min: 'ADMIN',
        Comp: Guardia,
      },
      {
        id: 'tickets-config-mesa',
        etiqueta: 'Configuración de la mesa',
        icono: Settings2,
        min: 'ADMIN',
        Comp: ConfiguracionMesa,
      },
      {
        id: 'tickets-avisos-automaticos',
        etiqueta: 'Avisos automáticos',
        icono: BellRing,
        min: 'ADMIN',
        Comp: FuentesAutomaticas,
      },
    ],
  }],
};
